/**
 * @Author: wuyang
 * @Date: 2024/1/8
 * @Description: ""
 */

import { IUseGuide, IUploadGuide } from '@/types/user'
import { requestInstance } from './instance'

/**
 * 获取验证码
 * @param phone
 */
export const getVerificationCode = (phone: any,captchaCode: any,captchaUuid: any) => {
	return requestInstance
		.get<any, { numberCode: number }>('/verification/code', {
			phone,
			captchaCode,
			captchaUuid
		})
		.fire()
}

/**
 * 手机号登录
 * @param params
 */
export const verificationCodeCheck = (params: {
	frontUserPhone: string
	verificationCode: string
	captchaCode?: string
	captchaUuid?: string
	type: number
	openId?: string
}) => {
	return requestInstance
		.post<
			any,
			{
				accessToke: string
				flag: boolean
			}
		>('/verification/code-check', params)
		.fire()
}

/**
 * 获取微信登录二维码信息
 * @param userId
 */
export const getQRCode = ({ userId }: { userId?: string }) => {
	const url = `/wechat/getQrCode` + (userId ? `?userId=${userId}` : '')
	return requestInstance
		.get<
			any,
			{
				qrCode: string
				uuid: string
				qrUrl: string
			}
		>(url, {})
		.fire()
}

/**
 * 根据微信二维码获取的 uuid 来不断获取 token
 * @param uuid
 */
export const getTokenByQRCode = ({ uuid }: { uuid: string }) => {
	return requestInstance.get<any, string>(`/token/${uuid}`, {}).fire()
}

/**
 * 通过wxOpenId删除前台用户信息,仅仅测试使用
 * @param uuid
 */
export const delUserOpenId = ({ openId }: { openId: string }) => {
	return requestInstance
		.get<any, string>(`/front/user/remove/${openId}`, {})
		.fire()
}

/**
 * 清空扫码失败后的值
 */
export const resetBindState = () => {
	return requestInstance
		.get<any, any>(`/front/user/front/resetBindState`, {})
		.fire()
}

/**
 * 退出登录
 */
export const userLogout = () => {
	return requestInstance.get<any, any>(`/front/user/logout`, {}).fire()
}

/**
 * 设置密码
 */
export const updatePasswordByOld = ({
	oldPassword,
	newPassword,
	userId
}: {
	oldPassword: string
	newPassword: string
	userId: string
}) => {
	return requestInstance
		.post<any, any>(`/front/user/updatePasswordByOld`, {
			oldPassword,
			newPassword,
			userId
		})
		.fire()
}

/**
 * 获取用户协议
 * @param type 隐私政策和用户协议(0-用户协议，1-隐私政策)
 */
export const getProtocol = ({ type }: { type: 0 | 1 }) => {
	return requestInstance
		.get<
			any,
			{
				content: string
				title: string
			}
		>(`/front/web/info/protocol/${type}`, {})
		.fire()
}

/**
 * 获取公司企业信息
 */
export const getBisInfo = () => {
	return requestInstance
		.get<
			any,
			{
				companyName: string
				customizedBusinessContent: string
				customizedBusinessName: string
				recordNumber: string
				upLoadGuideUrl: string
				useGuideUrl: string
				tBaseinfoContactusList: IUploadGuide[]
				tBaseinfoUseguideList: IUseGuide[]
			}
		>(`/front/web/info/base`, {})
		.fire()
}
/**
 * 创建团队
 */
export const createTeam = (data: any) => {
	return requestInstance
		.post('/front/team/create', data)
		.fire()
}
/**
 * 切换团队模式
 */
export const switchTeamMode = (data: any) => {
	return requestInstance
		.post('/front/team/switch', data)
		.fire()
}
/**
 * 团队成员列表
 */
export const getTeamMembers = (data: any) => {
	return requestInstance
		.get('/front/team/members', data)
		.fire()
}
/**
 * 批量添加团队成员
 */
export const batchAddTeamMembers = (data: any) => {
	return requestInstance
		.post('/front/team/members/batch-add', data)
		.fire()
}
/**
 * 检查手机号是否在团队中
 */
export const checkPhoneInTeam = (data: any) => {
	return requestInstance
		.upload('/front/team/check-phone-in-team', data)
		.fire()
}
/**
 * 移除团队成员
 */
export const removeTeamMember = (data: any) => {
	return requestInstance
		.del(`/front/team/members/${data.teamId}/${data.userId}`, data)
		.fire()
}
/**
 * 成员设为管理员
 */
export const editpermission = (data: any) => {
	return requestInstance
		.put('/front/team/editpermission', data)
		.fire()
}
/**
 * 获取当前用户团队信息
 */
export const getCurrentTeamInfo = (data: any) => {
	return requestInstance
		.get('/front/team/current', data)
		.fire()
}
/**
 * 修改用户团队信息
 */
export const updateTeamInfo = (data: any) => {
	return requestInstance
		.put(`/front/team/update/${data.teamId}`, data)
		.fire()
}
/**
 * 管理员修改团队成员昵称接口
 */
export const updateMemberNickname = (data: any) => {
	return requestInstance
		.put(`/front/team/members/${data.teamId}/${data.userId}/nickname`, data)
		.fire()
}
/**
 * 修改个人信息
 */
export const updatePersonalInfo = (data: any) => {
	return requestInstance
		.put('/front/user/updatePersonalInfo', data)
		.fire()
}
/**
 * 用户修改自己在团队中的信息
 */
export const updateTeamSelfInfo = (data: any) => {
	return requestInstance
		.put('/front/team/member/update-info', data)
		.fire()
}
/**
 * 团队积分记录列表接口
 */
export const getTeamScoreHistory = (data: any) => {
	return requestInstance
		.get('/front/team/scoreHistory', data)
		.fire()
}
/**
 * 用户积分记录列表接口
 */
export const getUserScoreHistory = (data: any) => {
	return requestInstance
		.get('/front/user/scoreHistory', data)
		.fire()
}
/**
 * 团队成员积分消耗统计接口
 */
export const getMemberScoreStatistics = (data: any) => {
	return requestInstance
		.get('/front/team/memberScoreStatistics', data)
		.fire()
}
/**
 * 导出团队成员积分消耗表格接口
 */
export const exportMemberScoreStatistics = (data: any) => {
	return requestInstance
		.downloadPost('/front/team/scoreHistory/export', data)
		.fire()
}
/* 获取图片验证码 */
export const getServerImageCode = () => {
	return requestInstance
		.get('/front/captcha/image', {})
		.fire()
}
/* 注册 */
export const register = (data: any) => {
	return requestInstance
		.post('/front/register/user', data)
		.fire()
}
/* 忘记密码 */
export const forgetPassword = (data: any) => {
	return requestInstance
		.post('/front/reset/password', data)
		.fire()
}
/**
 * 解散团队
 */
export const dissolveTeam = (data: any) => {
	return requestInstance
		.del(`/front/team/dissolve/${data.teamId}`, {})
		.fire()
}

